import { SectionHeading } from "@/components/shared/SectionHeading";
import { RevealStagger, RevealItem } from "@/components/shared/Reveal";
import { Search, ShieldCheck, Route, Wallet, Handshake, Flag, FileCheck2, BadgeCheck } from "lucide-react";

const STEPS = [
  { n: "01", icon: Search, title: "Create or Find an Assignment", copy: "A carrier, owner operator, RV owner, dealer, or authorized requester creates a transportation opportunity. Drivers can search available opportunities." },
  { n: "02", icon: ShieldCheck, title: "Verify Requirements", copy: "RelayRigs checks identity, CDL, license class, endorsements, medical qualification, equipment experience, ELD connection, HOS availability and insurance eligibility." },
  { n: "03", icon: BadgeCheck, title: "Match", copy: "The marketplace helps identify drivers based on location, qualifications, availability, equipment experience, and job requirements." },
  { n: "04", icon: Wallet, title: "Secure Payment", copy: "Required driver compensation is funded through the applicable payment workflow before eligible work begins. Drivers see whether compensation is secured." },
  { n: "05", icon: Handshake, title: "Pickup or Handoff", copy: "The driver navigates to the pickup, vehicle, or relay location. RelayRigs documents the applicable transfer of custody." },
  { n: "06", icon: Route, title: "Complete the Trip", copy: "After pickup or verified handoff, navigation changes to the destination." },
  { n: "07", icon: FileCheck2, title: "Verify Delivery", copy: "Capture the required delivery evidence, including signatures, photographs, GPS and documentation where applicable." },
  { n: "08", icon: Flag, title: "Process Payment", copy: "Once agreed payment release conditions are satisfied, the payment enters the payout process." },
];

export const HowItWorks = () => {
  return (
    <section id="how" data-testid="how-it-works-section" className="py-24 md:py-32 bg-rr-surface">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <SectionHeading
          eyebrow="How RelayRigs Works"
          title="One Marketplace. A Better Way to Keep Transportation Moving."
          testId="how-it-works"
        />

        <RevealStagger className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {STEPS.map((step) => (
            <RevealItem key={step.n}>
              <div data-testid={`how-it-works-step-${step.n}`} className="relative bg-white rounded-2xl p-6 h-full border border-rr-line hover:border-rr-orange/50 hover:-translate-y-1 transition-all shadow-sm">
                <span className="absolute right-5 top-5 font-heading text-4xl font-black text-rr-navy/[0.07]">{step.n}</span>
                <div className="w-12 h-12 rounded-xl bg-rr-orange/10 text-rr-orange flex items-center justify-center mb-5">
                  <step.icon size={22} />
                </div>
                <h3 className="font-heading font-bold text-lg text-rr-navy">{step.title}</h3>
                <p className="text-sm text-rr-muted mt-2 leading-relaxed">{step.copy}</p>
              </div>
            </RevealItem>
          ))}
        </RevealStagger>
      </div>
    </section>
  );
};
